/**
 *
 * @param transaction
 * @returns {{}}
 */
export default function transactionSerializer(transaction){
	const data = {};
	data.id = transaction.id;
	data.where = transaction.where;
	data.splits = transaction.splits.map((split) => {
		return split.serialize();
	});
	data.description = transaction.description;
	data.category_id = transaction.category_id;
	data.amount = transaction.amount;
	if(transaction.transaction_date){
		if(Number.parseInt(transaction.transaction_date, 10)){
			data.transaction_date = transaction.transaction_date;
		}
		else{
			data.transaction_date = transaction.transaction_date.unix();
		}
	}
	else{
		data.transaction_date = null;
	}
	if(transaction.plaid_transaction_id) {
		data.plaid_transaction_id = transaction.plaid_transaction_id;
	}
	if(transaction.submit_id) {
		data.submit_id = transaction.submit_id;
	}
	data.deleted = transaction.deleted;
	data.submitError = transaction.submitError;
	return data;
}

/**
 * What to POST to budget/transactions. The server leaves splits alone when none are sent, and a
 * form-encoded empty array sends nothing, so "no splits" goes as `['']`, which clears them. Kept out
 * of transactionSerializer, whose output is also stored offline and read back as a Transaction.
 */
export function transactionPostData(transaction) {
	const data = transactionSerializer(transaction);
	if(!data.splits.length) {
		data.splits = [''];
	}
	return data;
}
